import DetailsRoute from "routes/Details/DetailsRoute";

export default DetailsRoute;
